import { SupportDetailAdminCheckTransferComponent } from "../../../components/SupportSystem/Admin/SupportDetailAdminCheckTransferComponent"
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function SupportDetailAdminCheckTransferContainer () {
    const titleName = "รายละเอียดคำขอรับเงินช่วยเหลือหรืออุดหนุน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem  />
            <HeadTitle title={titleName} />
            <SupportDetailAdminCheckTransferComponent/>
            <Footer />
        </div>   
    )
}